import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ContactForm from './components/ContactForm';
import TrustBadges from './components/TrustBadges';
import Services from './components/Services';
import Automation from './components/Automation';
import Industries from './components/Industries';
import Results from './components/Results';
import CTA from './components/CTA';
import Footer from './components/Footer';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'MillionDollarMed | Healthcare Digital Marketing Agency | HIPAA-Compliant Patient Growth',
    description: 'MillionDollarMed is a full-service digital marketing agency for healthcare providers. HIPAA-compliant patient acquisition, automated lead nurturing, and practice growth for hormone therapy, longevity medicine, and wellness clinics.',
    keywords: 'healthcare marketing, medical marketing agency, HIPAA compliant marketing, patient acquisition, hormone therapy marketing, longevity medicine marketing, medical practice growth',
    canonical: `${siteUrl}/`,
    schema: {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "MillionDollarMed",
      "description": "Full-service digital marketing agency specializing in HIPAA-compliant patient acquisition and practice growth for healthcare providers",
      "url": siteUrl,
      "areaServed": "US",
      "serviceType": [
        "Healthcare Digital Marketing",
        "Medical SEO",
        "HIPAA-Compliant Marketing",
        "Patient Acquisition",
        "Marketing Automation"
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <ContactForm />
      <TrustBadges />
      <Services />
      <Automation />
      <Industries />
      <Results />
      <CTA />
      <Footer />
    </div>
  );
}
